const FilterIcon = (width = 24, height = 24, color = '#00675D') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24"><path d="M1 0l9 15.094V21l4 3v-8.906L23 0H1zm18.479 2l-2.981 5H7.502L4.521 2h14.958z" fill="${color}"/></svg>
`;

export default FilterIcon;
